// src/components/MessageQueueIndicator.tsx
import React from 'react';
import './MessageQueueIndicator.scss';

interface MessageQueueIndicatorProps {
  count: number;
}

export const MessageQueueIndicator: React.FC<MessageQueueIndicatorProps> = ({ count }) => {
  // Limit the maximum number of dots to display
  const MAX_DOTS = 10;
  const dotsToShow = Math.min(count, MAX_DOTS);

  return count > 0 ? (
    <div className="message-queue-indicator">
      {Array.from({ length: dotsToShow }).map((_, index) => (
        <div key={index} className="dot" />
      ))}
      {count > MAX_DOTS && <div className="more-indicator">+{count - MAX_DOTS}</div>}
    </div>
  ) : null;
};